import {
    Box,
    Button,
    Card,
    CardContent,
    Stack,
    Typography
} from "@mui/material";
import busLogo from "../assets/images/Fevi.png";
import { RequiredTextField } from "../utils/constants/utility";
import { useState } from "react";
import { post } from "../services/api";
import ENDPOINTS from "../utils/constants/endpoints";

const ChangePassword = () => {
    const [form, setForm] = useState({
        old_password: "",
        password: "",
        retype_password: ""
    })
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("")


    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    }

    const handleSubmit = async () => {
        setError("");
        setSuccess("")
      //  setLoading(true)
        const token = localStorage.getItem('token')
        const payload = {
            "token": token,
            
            "password": form.password,
            "retype_password": form.retype_password
        }
        const response = await post(ENDPOINTS.AUTH.CHANGE_PASSWORD, payload)
        console.log("response", response)
        if(response?.data?.status){
            setError("Password Change Successfully")
        }
        else{
            setError("Password Not Changed")
        }
        // if(response.data.status==false && response.code==="503"){
        // setLoading(false)
        // setError("Invalid old password.")    
        // }
        
        
    }

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight={{ xs: "auto", md: "100vh" }}
            py={{ xs: 1, md: 0 }}
        >
            <Card
                variant="outlined"
                sx={{
                    width: "100%",
                    maxWidth: 420,
                    p: { xs: 0.5, sm: 2 },
                    borderRadius: 2,
                }}
            >
                <CardContent>
                    {/* Logo */}
                    <Box display="flex" justifyContent="center" mb={2}>
                        <img src={busLogo} alt="Bus Logo" style={{ width: 120 }} />
                    </Box>

                    {/* Title */}
                    <Typography variant="h6" textAlign="center" mb={3}>
                        Change Password
                    </Typography>

                    {/* Form */}
                    <Stack spacing={2}>
                        {/* <RequiredTextField
                            fullWidth
                            required
                            label="Current Password"
                            name="old_password"

                            placeholder="Enter your current password"
                            onChange={handleChange}
                        /> */}

                        <RequiredTextField
                            fullWidth
                            required
                            label="New Password"
                            name="password"
                            placeholder="Enter new password"
                            onChange={handleChange}
                        />

                        <RequiredTextField
                            fullWidth
                            required
                            label="Confirm Password"
                            name="retype_password"
                            placeholder="Confirm new password"
                            onChange={handleChange}
                        />

                        <Button
                            variant="contained"
                            size="large"
                            sx={{ mt: 2 }}
                            fullWidth
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                             {loading ? "Updating..." : "Submit"}
                        </Button>
                        <Typography>{error}</Typography>
                    </Stack>
                </CardContent>
            </Card>
        </Box>
    );
};

export default ChangePassword;
